import { GET } from "services/httpService";
import { origin } from "helpers/originHelper";

export const getConfig = () => {
  return GET(null, `${origin}/config.json`);
};

export const getLocale = localeId => {
  return GET(null, `${origin}/locales/${localeId}.json`);
};
